export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40da01c187480ea05c08db43c900a0a5b9f4ab898e&name=revalidateCommunity!'